import React from "react";
import { Link } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";
import { useGetAllUserQuery } from "../../redux/slices/api/userApi";
import { Bars } from "react-loader-spinner";
import UserCard from "../common/UserCard";

const RecentJoinedResearchers = () => {
  const { isLoading, data: allUsersData } = useGetAllUserQuery({
    limit: 9,
  });

  return (
    <div className="w-full flex flex-col">
      {/* Section Header */}
      <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12">
        <div className="flex flex-col items-center sm:items-start">
          <span className="text-primary roboto-font text-sm font-medium uppercase tracking-wider mb-3">
            Community
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl abel-font text-secondary text-center sm:text-left">
            Recently Joined Users
          </h2>
        </div>
        <Link
          to="/users"
          className="hidden sm:flex group items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-primary/10 to-primary-green/10 hover:from-primary/20 hover:to-primary-green/20 border border-primary/20 transition-all duration-300"
        >
          <span className="text-primary font-medium">See all users</span>
          <HiChevronRight
            className="text-primary group-hover:translate-x-1 transition-transform duration-300"
            size={20}
          />
        </Link>
      </div>

      {isLoading ? (
        <div className="w-full min-h-[480px] flex justify-center items-center">
          <div className="flex flex-col items-center gap-4">
            <Bars
              height="50"
              width="50"
              color="#8538ff"
              ariaLabel="bars-loading"
              visible={true}
            />
            <span className="text-gray-500 roboto-font">Loading users...</span>
          </div>
        </div>
      ) : allUsersData?.length > 0 ? (
        <div className="w-full grid grid-cols-1 mlg:grid-cols-2 2xl:grid-cols-3 gap-5">
          {allUsersData?.map((user) => (
            <UserCard key={user?._id} userData={user} />
          ))}
        </div>
      ) : (
        <div className="w-full min-h-[400px] flex flex-col justify-center items-center empty-state-container-light p-12">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary/10 to-primary-green/10 flex items-center justify-center mb-6">
            <svg className="w-10 h-10 text-primary/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 className="text-2xl font-semibold text-secondary mb-2">No Users Yet</h3>
          <p className="text-gray-500 text-center max-w-md mb-6">
            Be among the first to join our growing community of researchers and backers.
          </p>
          <Link
            to="/register"
            className="px-6 py-3 bg-gradient-to-r from-primary to-[#7e7cff] text-white rounded-xl font-medium hover:shadow-lg hover:shadow-primary/20 transition-all duration-300"
          >
            Join Now
          </Link>
        </div>
      )}
      
      {/* Mobile See All Link */}
      {allUsersData?.length > 0 && (
        <div className="w-full flex justify-center items-center mt-8 sm:hidden">
          <Link
            to="/users"
            className="group flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-primary/10 hover:bg-primary/20 border border-primary/20 transition-all duration-300"
          >
            <span className="text-primary font-medium">See all users</span>
            <HiChevronRight
              className="text-primary group-hover:translate-x-1 transition-transform duration-300"
              size={20}
            />
          </Link>
        </div>
      )}
    </div>
  );
};

export default RecentJoinedResearchers;
